import { getMultiSectionFigmaLayout } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/sections.common';
import { addHeaderMobileLayout } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/headerColumns2/mobile/addHeaderMobileLayout';
import { addHeaderColumns3 } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/headerColumns3/addHeaderColumns3';

import type { ViewData } from '../../common/multisection.data';

export async function addHeaderColumns2(viewData: ViewData): Promise<ViewData> {
  if (getMultiSectionFigmaLayout(viewData) === 'full') {
    return addHeaderColumns3(viewData);
  }

  return addHeaderMobileLayout(viewData);
}
